import { AnyAction } from '@reduxjs/toolkit'

import { FETCH_CATALOG_APP_INSTANCE_SUCCESS } from '@/pages/SpaceCatalogAppDetailsPage/actionTypes'

import {
  FETCH_CONNECTOR_LOGS_RESET,
  FETCH_CONNECTOR_LOGS_SUCCESS,
  FETCH_CUSTOM_CONNECTOR_INSTANCE_RESET,
  FETCH_CUSTOM_CONNECTOR_INSTANCE_SUCCESS
} from './actionTypes'

type SpaceConnectorLogsPageState = {
  logs: unknown[]
  hasMore?: boolean
  totalResults?: any
  offset?: number
  customConnector?: unknown
}

export const initialState: SpaceConnectorLogsPageState = {
  logs: []
}

export default (state = initialState, action: AnyAction): SpaceConnectorLogsPageState => {
  switch (action.type) {
    case FETCH_CONNECTOR_LOGS_SUCCESS: {
      return {
        ...state,
        logs: action.response.results,
        hasMore: action.response.hasMore,
        totalResults: action.response.totalResults,
        offset: action.response.offset
      }
    }
    case FETCH_CONNECTOR_LOGS_RESET: {
      return { ...state, logs: [], hasMore: false, totalResults: 0, offset: 0 }
    }
    case FETCH_CATALOG_APP_INSTANCE_SUCCESS: {
      return { ...state, customConnector: action.response }
    }
    case FETCH_CUSTOM_CONNECTOR_INSTANCE_SUCCESS: {
      return { ...state, customConnector: action.response }
    }
    case FETCH_CUSTOM_CONNECTOR_INSTANCE_RESET: {
      return { ...state, customConnector: {} }
    }
    default: {
      return state
    }
  }
}
